import { takeLatest, put } from "redux-saga/effects";

import { canvasInfoActions } from "actions/canvasInfoActions.js";

import { GET_DATA } from "actions/apiOperations.js";
import { PATCH_DATA } from "actions/apiOperations.js";

export const requestCanvasInfo = function* (action) {
  const { buyplanId, month, ...params } = action.payload;

  yield put({
    type: GET_DATA,
    path: `/api/buyplans/${buyplanId}/canvas_state/${month}`,
    actions: canvasInfoActions,
    params
  });
};

export const udpateCanvasInfo = function* (action) {
  const { buyplanId, month, canvasData } = action.payload;

  yield put({
    type: PATCH_DATA,
    path: `/api/buyplans/${buyplanId}/canvas_state/${month}`,
    actions: canvasInfoActions,
    params: { canvas_state: canvasData },
  });
};

export const watchCanvasInfo = function* () {
  yield takeLatest(
    canvasInfoActions.request,
    requestCanvasInfo
  );
};

export const watchUpdateCanvasInfo = function* () {
  yield takeLatest(
    canvasInfoActions.update,
    udpateCanvasInfo
  );
};
